function addCartChangeJs(params) {
  return new Promise((resolve) => {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then(async (response) => {
      resolve(response.json());
    });
  });
}
function addCartAddJs(params) {
  return new Promise((resolve, reject) => {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }).then(async (response) => {
      resolve(response.json());
    });
  });
}
function addApiFbappMiniActivityCountdown(params) {
  const baseUrl = $("input[data-base-url]").val();
  return new Promise((resolve, reject) => {
    fetch(`${baseUrl}/api/fbapp/mini/activity/countdown`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(async (response) => {
        if (response.code === 2000) {
          resolve(response.data);
        }
      });
  });
}

function tryOnValidate(spuId) {
  const baseUrl = $("input[data-base-url]").val();
  const tryOnUserCode =
    localStorage.getItem("tryOnUserCode") || Date.now().toString();
  localStorage.setItem("tryOnUserCode", tryOnUserCode);
  const handleParts = spuId.split("-");
  const spuIdText = handleParts[handleParts.length - 1].trim();
  const params = {
    spuId: spuIdText,
    shopifyUid: $("input[data-customer-id]").val(),
    userCode: localStorage.getItem("tryOnUserCode"),
    email: $("input[data-customer-email]").val(),
  };
  return new Promise((resolve, reject) => {
    fetch(`${baseUrl}/api/fbapp/shopify/try/on/validate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(async (response) => {
        if (response.code === 2000) {
          resolve(response.data);
        }
      });
  });
}
const tryOnValidationCache = new Map();

async function aiTryOnShow() {
  const icons = document.querySelectorAll(
    'fabrique-try-on-icon[data-ai-handle="true"]'
  );
  for (const icon of icons) {
    const handle = icon.dataset.handle;
    if (tryOnValidationCache.has(handle)) {
      icon.style.display = tryOnValidationCache.get(handle) ? "flex" : "none";
      continue;
    }
    try {
      const result = await window.tryOnValidate?.(handle);
      const isValid = result?.isCan ?? false;
      tryOnValidationCache.set(handle, isValid);
      icon.style.display = isValid ? "flex" : "none";
    } catch {
      tryOnValidationCache.set(handle, false); // 失败也缓存
      icon.style.display = "none";
    }
  }
}

function addApiFbappMiniNoticeCountdown() {
  const baseUrl = $("input[data-base-url]").val();
  return new Promise((resolve, reject) => {
    fetch(`${baseUrl}/api/fbapp/mini/notice/countdown`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (response) => {
        if (response.code === 2000) {
          resolve(response.data);
        }
      });
  });
}
function getsuggestionsJs() {
  return new Promise((resolve) => {
    fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}` +
        "&language[enabled]=true" +
        `&language[exclude]=${window.Shopify.language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(),
      }
    ).then(async (response) => {
      resolve(response.json());
    });
  });
}
function setPageScrollStatus(status) {
  if (status) {
    $("body").css("overflow", "");
  } else {
    $("body").css("overflow", "hidden");
  }
}
function showToast(message) {
  setPageScrollStatus(false);
  var toast = `
    <div class="fabrique-toast">
        <div class="fabrique-toast-text">${message}</div>
    </div>
  `;
  $("body").append(toast);
  setTimeout(function () {
    $(".fabrique-toast").remove();
    setPageScrollStatus(true);
  }, 2000);
}
function showLoading(element, status = true) {
  const $containers = element
    ? $(`.${element}`) || $(`#${element}`)
    : $(`body`);
  const loadingElement = `
       <div class="fabrique-loading-mask">
        <div class="loading-wrapper">
            <svg class="loading-svg-line" xmlns="http://www.w3.org/2000/svg" width="216" height="3" viewBox="0 0 216 3"
                fill="none">
                <path d="M-3.5 2L220.228 1.84448" stroke="#031C24" stroke-width="2" stroke-linecap="round" />
            </svg>
            <div class="loading-svg-wrapper">

                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M20.3125 14.8327C20.3125 14.8327 20.3125 14.6356 20.3125 14.4743C20.5608 12.8796 23.523 12.6287 26.6626 10.6398C27.2479 10.2635 28.0283 9.72592 28.862 8.9375C29.7134 9.72592 30.4761 10.2635 31.0615 10.6398C34.201 12.6287 37.1455 12.8617 37.4115 14.4743C37.4293 14.6356 37.4115 14.761 37.4115 14.8327"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M31.415 2.57649C30.9538 1.64473 29.996 1.01758 28.8963 1.01758C27.3531 1.01758 26.0938 2.2898 26.0938 3.84871C26.0938 5.40762 27.3531 6.67984 28.8963 6.67984V8.93758"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.1954 33.3211C50.5068 34.3137 49.1021 34.474 48.2077 33.662L47.9752 33.4508C46.6657 32.262 44.5708 33.2332 44.632 35.0008L45.4785 59.4477C45.5176 60.5787 44.6114 61.5169 43.4797 61.5169H12.8549C11.7232 61.5169 10.8169 60.5787 10.8561 59.4477L11.7025 35.0008C11.7637 33.2332 9.6689 32.262 8.35939 33.4508L8.12685 33.662C7.23241 34.474 5.82775 34.3137 5.13918 33.3211L0.94739 27.2784C0.398242 26.4868 0.491536 25.4162 1.16933 24.7315L10.3364 15.4708C10.6279 15.1764 11.0037 14.9798 11.4117 14.9077C13.5818 14.5243 15.7431 14.132 17.9113 13.7467C18.7604 13.5957 19.5941 14.0211 20.1075 14.714C22.0104 17.2826 25.0459 18.8053 28.256 18.7274C31.3036 18.65 34.1133 17.13 35.9086 14.6747C36.421 13.974 37.2603 13.5444 38.115 13.6963C39.3407 13.9142 40.9261 14.196 41.1157 14.2298C42.3818 14.461 43.6609 14.6788 44.9306 14.9063C45.334 14.9785 45.7047 15.1744 45.993 15.4656L55.1652 24.7315C55.843 25.4162 55.9363 26.4868 55.3872 27.2784L51.1954 33.3211Z"
                        fill="#EDF0F0" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M19.793 14.8151C19.793 14.8151 19.793 14.618 19.793 14.4568C20.0413 12.862 23.0035 12.6111 26.143 10.6222C26.7284 10.2459 27.5088 9.70834 28.3425 8.91992C29.1939 9.70834 29.9566 10.2459 30.5419 10.6222C33.6815 12.6111 36.6259 12.8441 36.892 14.4568C36.9097 14.618 36.892 14.7435 36.892 14.8151"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M30.8994 2.55891C30.4382 1.62715 29.4804 1 28.3807 1C26.8375 1 25.5781 2.27222 25.5781 3.83113C25.5781 5.39004 26.8375 6.66226 28.3807 6.66226V8.92"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.5313 33.3387C50.8427 34.3313 49.4381 34.4916 48.5436 33.6795L48.3111 33.4684C47.0016 32.2796 44.9068 33.2508 44.968 35.0184L45.8144 59.4652C45.8536 60.5963 44.9473 61.5345 43.8156 61.5345H13.1908C12.0591 61.5345 11.1529 60.5963 11.192 59.4652L12.0385 35.0184C12.0997 33.2508 10.0048 32.2796 8.69532 33.4684L8.46278 33.6795C7.56835 34.4916 6.16369 34.3313 5.47512 33.3387L1.28333 27.296C0.734179 26.5044 0.827473 25.4337 1.50527 24.749L10.6723 15.4884C10.9638 15.194 11.3396 14.9974 11.7476 14.9253C13.9177 14.5419 16.0791 14.1496 18.2473 13.7642C19.0963 13.6133 19.9301 14.0386 20.4434 14.7316C22.3464 17.3002 25.3819 18.8229 28.5919 18.745C31.6396 18.6676 34.4492 17.1476 36.2445 14.6923C36.7569 13.9916 37.5962 13.562 38.4509 13.7139C39.6767 13.9318 41.262 14.2136 41.4517 14.2474C42.7177 14.4785 43.9968 14.6964 45.2666 14.9238C45.6699 14.9961 46.0406 15.192 46.3289 15.4832L55.5012 24.749C56.179 25.4337 56.2723 26.5044 55.7231 27.296L51.5313 33.3387Z"
                        fill="#031C24" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M20.3125 14.8327C20.3125 14.8327 20.3125 14.6356 20.3125 14.4743C20.5608 12.8796 23.523 12.6287 26.6626 10.6398C27.2479 10.2635 28.0283 9.72592 28.862 8.9375C29.7134 9.72592 30.4761 10.2635 31.0615 10.6398C34.201 12.6287 37.1455 12.8617 37.4115 14.4743C37.4293 14.6356 37.4115 14.761 37.4115 14.8327"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M31.415 2.57649C30.9538 1.64473 29.996 1.01758 28.8963 1.01758C27.3531 1.01758 26.0938 2.2898 26.0938 3.84871C26.0938 5.40762 27.3531 6.67984 28.8963 6.67984V8.93758"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.1954 33.3211C50.5068 34.3137 49.1021 34.474 48.2077 33.662L47.9752 33.4508C46.6657 32.262 44.5708 33.2332 44.632 35.0008L45.4785 59.4477C45.5176 60.5787 44.6114 61.5169 43.4797 61.5169H12.8549C11.7232 61.5169 10.8169 60.5787 10.8561 59.4477L11.7025 35.0008C11.7637 33.2332 9.6689 32.262 8.35939 33.4508L8.12685 33.662C7.23241 34.474 5.82775 34.3137 5.13918 33.3211L0.94739 27.2784C0.398242 26.4868 0.491536 25.4162 1.16933 24.7315L10.3364 15.4708C10.6279 15.1764 11.0037 14.9798 11.4117 14.9077C13.5818 14.5243 15.7431 14.132 17.9113 13.7467C18.7604 13.5957 19.5941 14.0211 20.1075 14.714C22.0104 17.2826 25.0459 18.8053 28.256 18.7274C31.3036 18.65 34.1133 17.13 35.9086 14.6747C36.421 13.974 37.2603 13.5444 38.115 13.6963C39.3407 13.9142 40.9261 14.196 41.1157 14.2298C42.3818 14.461 43.6609 14.6788 44.9306 14.9063C45.334 14.9785 45.7047 15.1744 45.993 15.4656L55.1652 24.7315C55.843 25.4162 55.9363 26.4868 55.3872 27.2784L51.1954 33.3211Z"
                        fill="#EDF0F0" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M19.5977 13.9013C19.846 12.3066 22.6722 12.6111 25.8118 10.6222C26.3971 10.2459 27.1776 9.70834 28.0113 8.91992C28.8627 9.70834 29.6254 10.2459 30.2107 10.6222C33.3503 12.6111 36.002 12.2886 36.2681 13.9013"
                        stroke="#021B23" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M32.0869 2.57845C31.6257 1.64668 30.6679 1.01953 29.5682 1.01953C28.025 1.01953 26.7656 2.29175 26.7656 3.85066C26.7656 5.40958 28.025 6.68179 29.5682 6.68179V8.93953"
                        stroke="#021B23" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.8672 33.3211C51.1787 34.3137 49.774 34.474 48.8796 33.662L48.647 33.4508C47.3375 32.262 45.2427 33.2332 45.3039 35.0008L46.1503 59.4477C46.1895 60.5787 45.2832 61.5169 44.1515 61.5169H13.5268C12.3951 61.5169 11.4888 60.5787 11.528 59.4477L12.3744 35.0008C12.4356 33.2332 10.3408 32.262 9.03126 33.4508L8.79872 33.662C7.90428 34.474 6.49963 34.3137 5.81106 33.3211L1.61927 27.2784C1.07012 26.4868 1.16341 25.4162 1.84121 24.7315L11.0083 15.4708C11.2998 15.1764 11.6755 14.9798 12.0835 14.9077C14.2536 14.5243 16.415 14.132 18.5832 13.7467C19.4323 13.5957 20.266 14.0211 20.7794 14.714C22.6823 17.2826 25.7178 18.8053 28.9278 18.7274C31.9755 18.65 34.7852 17.13 36.5805 14.6747C37.0928 13.974 37.9322 13.5444 38.7868 13.6963C40.0126 13.9142 41.598 14.196 41.7876 14.2298C43.0536 14.461 44.3328 14.6788 45.6025 14.9063C46.0059 14.9785 46.3766 15.1744 46.6649 15.4656L55.8371 24.7315C56.5149 25.4162 56.6082 26.4868 56.059 27.2784L51.8672 33.3211Z"
                        fill="#E88C73" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M20.3125 14.8327C20.3125 14.8327 20.3125 14.6356 20.3125 14.4743C20.5608 12.8796 23.523 12.6287 26.6626 10.6398C27.2479 10.2635 28.0283 9.72592 28.862 8.9375C29.7134 9.72592 30.4761 10.2635 31.0615 10.6398C34.201 12.6287 37.1455 12.8617 37.4115 14.4743C37.4293 14.6356 37.4115 14.761 37.4115 14.8327"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M31.415 2.57649C30.9538 1.64473 29.996 1.01758 28.8963 1.01758C27.3531 1.01758 26.0938 2.2898 26.0938 3.84871C26.0938 5.40762 27.3531 6.67984 28.8963 6.67984V8.93758"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.1954 33.3211C50.5068 34.3137 49.1021 34.474 48.2077 33.662L47.9752 33.4508C46.6657 32.262 44.5708 33.2332 44.632 35.0008L45.4785 59.4477C45.5176 60.5787 44.6114 61.5169 43.4797 61.5169H12.8549C11.7232 61.5169 10.8169 60.5787 10.8561 59.4477L11.7025 35.0008C11.7637 33.2332 9.6689 32.262 8.35939 33.4508L8.12685 33.662C7.23241 34.474 5.82775 34.3137 5.13918 33.3211L0.94739 27.2784C0.398242 26.4868 0.491536 25.4162 1.16933 24.7315L10.3364 15.4708C10.6279 15.1764 11.0037 14.9798 11.4117 14.9077C13.5818 14.5243 15.7431 14.132 17.9113 13.7467C18.7604 13.5957 19.5941 14.0211 20.1075 14.714C22.0104 17.2826 25.0459 18.8053 28.256 18.7274C31.3036 18.65 34.1133 17.13 35.9086 14.6747C36.421 13.974 37.2603 13.5444 38.115 13.6963C39.3407 13.9142 40.9261 14.196 41.1157 14.2298C42.3818 14.461 43.6609 14.6788 44.9306 14.9063C45.334 14.9785 45.7047 15.1744 45.993 15.4656L55.1652 24.7315C55.843 25.4162 55.9363 26.4868 55.3872 27.2784L51.1954 33.3211Z"
                        fill="#EDF0F0" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M19.793 14.8151C19.793 14.8151 19.793 14.618 19.793 14.4568C20.0413 12.862 23.0035 12.6111 26.143 10.6222C26.7284 10.2459 27.5088 9.70834 28.3425 8.91992C29.1939 9.70834 29.9566 10.2459 30.5419 10.6222C33.6815 12.6111 36.6259 12.8441 36.892 14.4568C36.9097 14.618 36.892 14.7435 36.892 14.8151"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M30.8994 2.55891C30.4382 1.62715 29.4804 1 28.3807 1C26.8375 1 25.5781 2.27222 25.5781 3.83113C25.5781 5.39004 26.8375 6.66226 28.3807 6.66226V8.92"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.5313 33.3387C50.8427 34.3313 49.4381 34.4916 48.5436 33.6795L48.3111 33.4684C47.0016 32.2796 44.9068 33.2508 44.968 35.0184L45.8144 59.4652C45.8536 60.5963 44.9473 61.5345 43.8156 61.5345H13.1908C12.0591 61.5345 11.1529 60.5963 11.192 59.4652L12.0385 35.0184C12.0997 33.2508 10.0048 32.2796 8.69532 33.4684L8.46278 33.6795C7.56835 34.4916 6.16369 34.3313 5.47512 33.3387L1.28333 27.296C0.734179 26.5044 0.827473 25.4337 1.50527 24.749L10.6723 15.4884C10.9638 15.194 11.3396 14.9974 11.7476 14.9253C13.9177 14.5419 16.0791 14.1496 18.2473 13.7642C19.0963 13.6133 19.9301 14.0386 20.4434 14.7316C22.3464 17.3002 25.3819 18.8229 28.5919 18.745C31.6396 18.6676 34.4492 17.1476 36.2445 14.6923C36.7569 13.9916 37.5962 13.562 38.4509 13.7139C39.6767 13.9318 41.262 14.2136 41.4517 14.2474C42.7177 14.4785 43.9968 14.6964 45.2666 14.9238C45.6699 14.9961 46.0406 15.192 46.3289 15.4832L55.5012 24.749C56.179 25.4337 56.2723 26.5044 55.7231 27.296L51.5313 33.3387Z"
                        fill="#031C24" />
                </svg>
                <svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 57 62"
                    fill="none">
                    <path
                        d="M20.3125 14.8327C20.3125 14.8327 20.3125 14.6356 20.3125 14.4743C20.5608 12.8796 23.523 12.6287 26.6626 10.6398C27.2479 10.2635 28.0283 9.72592 28.862 8.9375C29.7134 9.72592 30.4761 10.2635 31.0615 10.6398C34.201 12.6287 37.1455 12.8617 37.4115 14.4743C37.4293 14.6356 37.4115 14.761 37.4115 14.8327"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M31.415 2.57649C30.9538 1.64473 29.996 1.01758 28.8963 1.01758C27.3531 1.01758 26.0938 2.2898 26.0938 3.84871C26.0938 5.40762 27.3531 6.67984 28.8963 6.67984V8.93758"
                        stroke="#031C24" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M51.1954 33.3211C50.5068 34.3137 49.1021 34.474 48.2077 33.662L47.9752 33.4508C46.6657 32.262 44.5708 33.2332 44.632 35.0008L45.4785 59.4477C45.5176 60.5787 44.6114 61.5169 43.4797 61.5169H12.8549C11.7232 61.5169 10.8169 60.5787 10.8561 59.4477L11.7025 35.0008C11.7637 33.2332 9.6689 32.262 8.35939 33.4508L8.12685 33.662C7.23241 34.474 5.82775 34.3137 5.13918 33.3211L0.94739 27.2784C0.398242 26.4868 0.491536 25.4162 1.16933 24.7315L10.3364 15.4708C10.6279 15.1764 11.0037 14.9798 11.4117 14.9077C13.5818 14.5243 15.7431 14.132 17.9113 13.7467C18.7604 13.5957 19.5941 14.0211 20.1075 14.714C22.0104 17.2826 25.0459 18.8053 28.256 18.7274C31.3036 18.65 34.1133 17.13 35.9086 14.6747C36.421 13.974 37.2603 13.5444 38.115 13.6963C39.3407 13.9142 40.9261 14.196 41.1157 14.2298C42.3818 14.461 43.6609 14.6788 44.9306 14.9063C45.334 14.9785 45.7047 15.1744 45.993 15.4656L55.1652 24.7315C55.843 25.4162 55.9363 26.4868 55.3872 27.2784L51.1954 33.3211Z"
                        fill="#EDF0F0" />
                </svg>
            </div>
        </div>
    </div>
    `;
  if (status) {
    if (!window.loadingStatus) {
      window.loadingStatus = true;
      $containers.append(loadingElement);
      if (!element) {
        $(".fabrique-loading-mask").css({
          position: "fixed",
        });
      }
    }
  } else {
    window.loadingStatus = false;
    $(".fabrique-loading-mask").remove();
  }
}
function isMobile() {
  return $(window).width() < 767;
}
function handleGlobalError() {
  window.onerror = function (message, source, lineno, colno, error) {
    // 可以将错误信息发送到服务器或日志系统
    console.log(`Error: ${message} at ${source}:${lineno}:${colno}`);
    console.log(error); // 完整的 Error 对象
  };

  window.addEventListener(
    "error",
    function (event) {
      // 仅当加载资源失败时才会触发
      if (event.target !== window) {
        console.log(
          `Resource load error: ${event.target.src || event.target.href}`
        );
      }
    },
    true
  );
  window.addEventListener("unhandledrejection", function (event) {
    // 处理未捕获的 Promise 错误
    console.log("Unhandled Rejection:", event.reason);
  });
}
function apiFbappMiniMsgNoticeUpload(warnUrl, code) {
  var baseUrl = $("input[data-base-url]").val();
  fetch(`${baseUrl}/api/fbapp/mini/msg/notice/upload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      warnUrl: window.location.href,
      code,
    }),
  });
}
function initAnnouncementSwiper() {
  const el = document.querySelector(".announcement-wrapper");
  if (!el || el.swiper) return;
  const slides = el.querySelectorAll(".swiper-slide");
  if (slides.length <= 1) return;
  new Swiper(el, {
    direction: "vertical",
    loop: true,
    speed: 400,
    allowTouchMove: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
}
function handleShowCartDrawer(response, productId) {
  const $fabriqueGoodsDetailCartDrawerOverlayElement = $(
    ".fabrique-goods-detail-cart-drawer-overlay"
  );
  const $fabriqueGoodsDetailCartDrawerElement = $(
    ".fabrique-goods-detail-cart-drawer"
  );
  const $fabriqueGoodsDetailCartDrawerContentWrapper = $(
    ".fabrique-goods-detail-cart-drawer_content-wrapper"
  );
  let scrollTop;
  const sections = response.sections;
  window.updateCartSectionList.forEach((item) => {
    const html = sections[item.section];
    item.updateDomIdList.forEach((domId) => {
      $(`#${domId}`).html(
        new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(`#${domId}`).innerHTML
      );
      if ($(`#${domId}`).has("*").length) {
        if ($(`#${domId}`).css("display") == "none") {
          $(`#${domId}`).css({
            display: "block",
          });
        }
      } else {
        $(`#${domId}`).css({
          display: "none",
        });
      }
    });
  });
  function handleOpen() {
    window.setPageScrollStatus(false);
    $fabriqueGoodsDetailCartDrawerOverlayElement.css({
      opacity: 1,
      visibility: "visible",
    });
    scrollTop = window.scrollY || document.documentElement.scrollTop;
    document.body.style.cssText =
      "overflow:hidden; height:100vh; position:fixed; top:-" +
      scrollTop +
      "px; width:100%";
    $fabriqueGoodsDetailCartDrawerElement.css({
      right: 0,
    });
    $fabriqueGoodsDetailCartDrawerContentWrapper.animate(
      {
        scrollTop: 0,
      },
      0
    );
    initAnnouncementSwiper();
  }
  function handleClose() {
    window.setPageScrollStatus(true);
    $fabriqueGoodsDetailCartDrawerOverlayElement.css({
      opacity: 0,
      visibility: "hidden",
    });
    document.body.style.cssText = "";
    window.scrollTo(0, scrollTop); // 回到原位置
    $fabriqueGoodsDetailCartDrawerElement.css({
      right: "-100%",
    });
  }
  $(".fabrique-goods-detail-cart-drawer-overlay").on("click", () => {
    handleClose();
  });
  $(".fabrique-goods-detail-cart-drawer_header-close").on("click", () => {
    handleClose();
  });
  handleOpen();
  handleYouMayAlsoLikeRecommendationsRender(productId);
}
function handleYouMayAlsoLikeRecommendationsRender(productId) {
  const productRecommendationsSection = document.querySelector(
    "#fabrique-cart-drawer-you-may-also-like"
  );
  window.showLoading("fabrique-goods-detail-cart-drawer", true);
  fetch(
    `${window.Shopify.routes.root}recommendations/products?section_id=fabrique-guess-you-like&product_id=${productId}&limit=8&intent=related`
  )
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(".fabrique-you-may-also-like");
      if (recommendations && recommendations.innerHTML.trim().length) {
        const youMayAlsoLikeProducts = recommendations.querySelectorAll(
          ".fabrique-product-image-link"
        );
        youMayAlsoLikeProducts.forEach((item) => {
          item.setAttribute("data-title", "drawer");
        });
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .finally(() => {
      window.showLoading("fabrique-goods-detail-cart-drawer", false);
    });
}
function getRecentlyViewedProductIds() {
  let recentIds = window.localStorage.getItem(window.recentlyViewedKey);
  if (recentIds && typeof recentIds !== undefined) {
    recentIds = JSON.parse(recentIds);
  } else {
    recentIds = [];
  }
  return recentIds;
}
async function handleGoodsDetailPageActivityCountdown() {
  window.productPageActivityCountdownTimer &&
    clearInterval(window.productPageActivityCountdownTimer);
  const $activityCountdownElement = $(
    "#fabrique-goods-detail-page-activity-countdown"
  );
  const spuHandle = $("#fabrique-goods-detail-page").attr(
    "data-product-handle"
  );
  const countryCode = $("input[data-localization-country-code]").val();
  let { canShow, remainDuration } = await addApiFbappMiniActivityCountdown({
    spuHandle,
    countryCode,
  });
  canShow = Boolean(canShow);
  remainDuration = Number(remainDuration);
  remainDuration = remainDuration / 1000;
  if (canShow && remainDuration > 0) {
    window.productPageActivityCountdownTimer = setInterval(() => {
      if (remainDuration < 1) {
        window.productPageActivityCountdownTimer &&
          clearInterval(window.productPageActivityCountdownTimer);
        $activityCountdownElement.css({
          display: "none",
        });
      } else {
        remainDuration = remainDuration - 1;
        let hours = Math.floor(remainDuration / 3600);
        let minutes = Math.floor((remainDuration % 3600) / 60);
        let seconds = Math.floor(remainDuration % 60);
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;
        if ($activityCountdownElement.css("display") === "none") {
          $activityCountdownElement.css({
            display: "inline-block",
          });
        }
        $activityCountdownElement.html(`${hours}:${minutes}:${seconds}`);
      }
    }, 1 * 1000);
  }
}
function chunkArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

function handleViewModelProductImage({ isInit } = {}) {
  window.showLoading();
  const modelViewStatus = $("[data-model-view-status]").attr(
    "data-model-view-status"
  );
  let localModelViewStatus =
    window.localStorage.getItem("localModelViewStatus") || "on";
  if (modelViewStatus == "off") {
    localModelViewStatus = "on";
  }
  if (localModelViewStatus == "on") {
    if (!isInit) {
      $(".fabrique-product-wrapper").each(function () {
        const first_img_src = $(this).attr("data-first_img_src");
        const second_img_src = $(this).attr("data-second_img_src");
        const tiled_img_src = $(this).attr("data-tiled_img_src");
        const data_ab_variant = Number($(this).attr("data-ab-variant"));
        const $el = $(this);
        const aiImgs = (() => {
          try {
            return JSON.parse($el.attr("data_ai_img_src") || "[]");
          } catch {
            return [];
          }
        })();
        if (tiled_img_src) {
          if (data_ab_variant >= 1 && aiImgs[data_ab_variant - 1]) {
            $(this)
              .find(".fabrique-product-image")
              .attr("src", aiImgs[data_ab_variant - 1]);
          } else {
            $(this).find(".fabrique-product-image").attr("src", first_img_src);
          }
          $(this)
            .find(".fabrique-product-image-secondary")
            .attr("src", second_img_src);
        }
      });
    }
    $(".fabrique-sort-right-view-model-eye-open").css({
      display: "block",
    });
    $(".fabrique-sort-right-view-model-eye-close").css({
      display: "none",
    });
    $(".fabrique-sort-right-view-model").attr("data-title", "on");
  } else if (localModelViewStatus == "off") {
    $(".fabrique-product-wrapper").each(function () {
      const first_img_src = $(this).attr("data-first_img_src");
      const second_img_src = $(this).attr("data-second_img_src");
      const tiled_img_src = $(this).attr("data-tiled_img_src");
      if (tiled_img_src) {
        $(this).find(".fabrique-product-image").attr("src", tiled_img_src);
        $(this).find(".fabrique-product-image").attr("data-img-type", "1");
        $(this)
          .find(".fabrique-product-image-secondary")
          .attr("src", first_img_src);
      }
    });
    $(".fabrique-sort-right-view-model-eye-open").css({
      display: "none",
    });
    $(".fabrique-sort-right-view-model-eye-close").css({
      display: "block",
    });
    $(".fabrique-sort-right-view-model").attr("data-title", "off");
  }
  window.showLoading("", false);
}
function handleMainCollectionModelViewClickListener() {
  $(document).on("click", ".fabrique-sort-right-view-model", function () {
    const modelViewStatus = $("[data-model-view-status]").attr(
      "data-model-view-status"
    );
    const localModelViewStatus =
      window.localStorage.getItem("localModelViewStatus") || "on";
    if (modelViewStatus == "on") {
      if (localModelViewStatus == "on") {
        window.localStorage.setItem("localModelViewStatus", "off");
      } else {
        window.localStorage.setItem("localModelViewStatus", "on");
      }
    }
    window.handleViewModelProductImage();
  });
}
// 注册完成之后调用
function fabriqueregisterFormReward() {
  const subscribeStatus = localStorage.getItem("fabriqueregisterFormRewards");
  const customerId = $("input[data-customer-id]").val();
  if (subscribeStatus && customerId) {
    const baseUrl = $("input[data-base-url]").val();
    const formData = {
      id: customerId,
      emailMarketingConsent: 1,
    };
    fetch(`${baseUrl}/api/fbapp/shopify/user/info/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        localStorage.removeItem("fabriqueregisterFormRewards");
      })
      .catch((error) => {});
  }
}
// 处理index模版页面滚动时特殊处理的样式
let lastScrollTop = 0; // 在函数外部定义，确保每次调用都能记录上一次的scrollTop

function handleTemplateIndexScrollStyle() {
  const announcementBar = $("#fabrique-announcement-bar-wrapper");
  const announcementBarHeight = announcementBar.height();
  const header = $(".section-header");
  const scrollTop = $(window).scrollTop();
  // 判断滑动方向
  const isScrollDown = scrollTop > lastScrollTop;
  lastScrollTop = scrollTop;
  if (isScrollDown) {
    if (scrollTop >= announcementBarHeight) {
      header.css({
        top: "0px",
      });
      announcementBar.css({
        top: `-${announcementBarHeight}px`,
      });
    } else {
      header.css({
        top: `${announcementBarHeight - scrollTop}px`,
      });
      announcementBar.css({
        top: `-${
          scrollTop > announcementBarHeight ? announcementBarHeight : scrollTop
        }px`,
      });
    }
  } else {
    if (scrollTop >= announcementBarHeight) {
      header.css({
        top: "0px",
      });
      announcementBar.css({
        top: `-${announcementBarHeight}px`,
      });
    } else {
      header.css({
        top: `${announcementBarHeight - scrollTop}px`,
      });
      announcementBar.css({
        top: `-${
          scrollTop > announcementBarHeight ? announcementBarHeight : scrollTop
        }px`,
      });
    }
  }

  const height = $(window).height() / 4;
  if (scrollTop >= height) {
    if (!$(this.header).hasClass("section-header--scroll")) {
      requestAnimationFrame(() => {
        if (announcementBar) {
          announcementBar.addClass("fabrique-announcement-bar-wrapper--scroll");
        }
        header.addClass("section-header--scroll");
      });
    }
  } else {
    if (header.hasClass("section-header--scroll")) {
      requestAnimationFrame(() => {
        if (announcementBar) {
          announcementBar.removeClass(
            "fabrique-announcement-bar-wrapper--scroll"
          );
        }
        header.removeClass("section-header--scroll");
      });
    }
  }
}
// 处理index模版HeaderDrawer打开时特殊处理的样式
function handleTemplateIndexHeaderDrawerClick(type) {
  const announcementBar = $("#fabrique-announcement-bar-wrapper");
  const header = $(".section-header");
  const scrollTop = $(window).scrollTop();
  const height = $(window).height();
  if (type == "add") {
    if (!$(this.header).hasClass("section-header--scroll")) {
      requestAnimationFrame(() => {
        if (announcementBar) {
          announcementBar.addClass("fabrique-announcement-bar-wrapper--scroll");
        }
        header.addClass("section-header--scroll");
      });
    }
  }
  if (type == "remove" && scrollTop < height) {
    if (header.hasClass("section-header--scroll")) {
      requestAnimationFrame(() => {
        if (announcementBar) {
          announcementBar.removeClass(
            "fabrique-announcement-bar-wrapper--scroll"
          );
        }
        header.removeClass("section-header--scroll");
      });
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  fabriqueregisterFormReward();
  // 登录埋点
  const fabriqueLoginBurial = localStorage.getItem("fabriqueLoginBurial");
  const customerId = $("input[data-customer-id]").val();
  if (fabriqueLoginBurial && customerId) {
    setTimeout(function () {
      fbq("track", "CompleteSignIn");
    }, 5000);
    localStorage.removeItem("fabriqueLoginBurial");
  }
  const fabriqueRegisterBurial = localStorage.getItem("fabriqueRegisterBurial");
  // 注册成功
  if (fabriqueRegisterBurial && customerId) {
    setTimeout(function () {
      fbq("track", "CompleteRegistration");
    }, 5000);
    localStorage.removeItem("fabriqueRegisterBurial");
  }
});

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == "submit") {
    fbq("track", "Lead");
  }
});

function truncateText(selector, reserve = 0) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach((el) => {
    const style = getComputedStyle(el);
    const maxHeight = el.clientHeight - reserve;
    const fullText = el.dataset.fullText || el.innerText.trim();

    el.innerText = fullText;
    el.dataset.fullText = fullText;
    // 如果内容本来不溢出，就不处理
    if (el.scrollHeight <= el.clientHeight) return;
    let start = 0;
    let end = fullText.length;
    let truncated = "";
    // 二分法查找最合适截断点
    while (start <= end) {
      const mid = Math.floor((start + end) / 2);
      el.innerText = fullText.slice(0, mid) + "...";

      if (el.scrollHeight > maxHeight) {
        end = mid - 1;
      } else {
        truncated = fullText.slice(0, mid);
        start = mid + 1;
      }
    }
    el.dataset.truncated = truncated;
    el.innerText = truncated + "...";
  });
}

function isSafariPC() {
  const ua = navigator.userAgent;

  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isPC = !/Mobile|iPhone|iPad|iPod/i.test(ua);

  return isSafari && isPC;
}

document.addEventListener("click", function (event) {
  const button = event.target.closest(".rivo-button");
  if (button) {
    const buttonText = button.textContent.trim();
    if (buttonText == "Join Now") {
      fbq("track", "LoyaltyToRegistration");
    }
    if (buttonText == "Sign In") {
      fbq("track", "LoyaltyToSignIn");
    }
  }
  const link = event.target.closest(".rivo-modal__content a");
  if (link) {
    const linkText = link.textContent.trim();
    if (linkText == "Start Earning") {
      fbq("track", "LoyaltyToRegistration");
    }
    if (linkText == "Sign in") {
      fbq("track", "LoyaltyToSignIn");
    }
  }
  const register = event.target.closest("#create_customer button");
  if (register) {
    const registerText = register.textContent.trim();
    if (registerText == "Create Account") {
      fbq("track", "CreateAccount");
    }
  }

  const SignIn = event.target.closest("#customer_login button");
  if (SignIn) {
    const SignInText = SignIn.textContent.trim();
    if (SignInText == "Sign in") {
      fbq("track", "SignIn");
    }
  }
});
handleGlobalError();
